import { render, staticRenderFns } from "./custom-workviews.vue?vue&type=template&id=5997834c"
import script from "./custom-workviews.vue?vue&type=script&lang=js"
export * from "./custom-workviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports